var map = {
	"./empty-business-card.svg": 203,
	"./empty-dashboard.svg": 432,
	"./empty-default.svg": 157,
	"./empty-funnel.svg": 433,
	"./empty-kit-activity.svg": 204,
	"./empty-kit.svg": 434,
	"./empty-leads.svg": 435,
	"./empty-projects.svg": 436
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2044;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/empty\-.*\.svg$
// module id = 2044
// module chunks = 0